export default "__VITE_ASSET__BHzUJkYV__"